
  /**
   * Fotor APP mobile 通用模版
   */
  import { mapState } from 'vuex'
  import { setRem } from '~/utils/mobile'
  import { openApp } from '@Common'
  export default {
    layout: "default",
    computed: {
      ...mapState({
        fullLoadingData: state => state.mobile.fullLoadingData,
        toastLoadingData: state => state.mobile.toastLoadingData,
        msgBoxData: state => state.mobile.msgBoxData,
        toastData: state => state.mobile.toastData,
        confirmData: state => state.mobile.confirmData,
      })
    },
    data () {
      return {
        opacity: 0,
      }
    },
    created () {
      if (process.client) {
        setRem(document, window)
      }
    },
    mounted () {
      this.opacity = 1 // 解决网页加载闪烁问题
    },
  }
